import { createFileRoute } from '@tanstack/react-router';

import { FieldsListPage } from '@fields/feature';

export const Route = createFileRoute('/_app/fields')({
  component: FieldsListPage,
  errorComponent: FieldsListPage.Error,
});
